import React, { useEffect, useState } from 'react';
// import io from 'socket.io-client';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import LoadingComponent from '../../common/LoadingComponent';
import config from '../../config';
import styles from '../../styles/AttendeeStyles.module.scss';

const { baseUrl, client, clientDomainRgx } = config;

const isDev = process.env.NODE_ENV === 'development';

const AttendeeLandingPage = () => {
  // loop though all sessons for client
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState(false);
  const [attendeeStyles, setAttendeeStyles] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);

    const requestPayload = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: client,
        customClientDomain: clientDomainRgx.test(window.location.host) ? null : window.location.host
      })
    };
    fetch(`${baseUrl}/api/getAttendeeSessions`, requestPayload)
      .then((sessionData) => sessionData.json())
      .then((requestData) => {
        setAttendeeStyles(requestData.attendeeStyles);

        const twelveHoursPrior = moment().subtract(12, 'hours');
        const eod = moment().endOf('day');

        const todaysSessions = requestData.sessions.filter((session) => {
          // filter out sessions that are not bwetween 12 hours prior and end of day
          const isInRange = !isDev
            ? moment.utc(session.date).isBetween(twelveHoursPrior, eod)
            : true;
          return isInRange;
        });
        const sessionList = requestData.showAllFutureSessions
          ? requestData.sessions
          : todaysSessions;

        setSessions(sessionList);

        setLoading(false);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // <MobileSessionList
  //       sessions={}
  //       type={'attendeeSessions'}
  //     />
  if (!loading && sessions) {
    return (
      <div
        className={styles.eventsContainer}
        style={{
          '--border-color': attendeeStyles.containerBorderColor,
          '--background-color': attendeeStyles.background
        }}
      >
        <div style={attendeeStyles.styles}>
          {attendeeStyles.topLogo && (
            <div className={styles.audienceHeaderLogo}>
              <img alt="logo" src={attendeeStyles.topLogo} />
            </div>
          )}

          {_.isEmpty(sessions) ? (
            <h3
              style={{
                color: attendeeStyles.headerWordingColor,
                textAlign: 'center',
                margin: 50
              }}
            >
              There are no sessions today. Please visit again soon.
            </h3>
          ) : (
            <>
              <h1 style={{ color: attendeeStyles.headerWordingColor }}>
                {attendeeStyles.headerWording}
              </h1>
              {sessions.map((session, key) => (
                <div
                  className={styles.singleEventWrapper}
                  key={key}
                  style={{
                    '--border-color': attendeeStyles.eventBorderColor,
                    '--color': attendeeStyles.eventTextColor
                  }}
                >
                  <div>
                    <p>DATE:</p>
                    <p>{moment.utc(session.date).format('MM/DD/YYYY')}</p>
                  </div>
                  <div>
                    <p>PRESENTER:</p>
                    <p style={{ maxWidth: '60%' }}>{session.presenter}</p>
                  </div>
                  <div>
                    <p>EVENT:</p>
                    <p style={{ maxWidth: '60%' }}>{session.location}</p>
                  </div>
                  <div>
                    <button
                      type="submit"
                      style={{
                        background: attendeeStyles.buttonColor,
                        color: attendeeStyles.buttonWordingColor
                      }}
                      onClick={() => navigate(`/audience/${session.id}`)}
                    >
                      ENTER EVENT
                    </button>
                  </div>
                </div>
              ))}
            </>
          )}
          {/* <div className={styles.audienceFooter}>
            <img alt="logo" src={attendeeStyles.tertiaryLogo} />
          </div> */}
        </div>
      </div>
    );
  }

  return <LoadingComponent />;
};

export default AttendeeLandingPage;
